import React from "react";
import { Subscribe } from "unstated";
import { Metabar } from "idc-ui-react";
// Our Modules
import { store } from "../../stores/Main";
import ProfileToggle from "./ProfileToggle";
import Apps from "./Apps";
import Lists from "./Lists";
import QuickLinksList from "./QuickLinksList";
//import HelpMessages from "./HelpMessages";

const Dashboard = ({ store }) => {
  const { reports, loggedInUser, category } = store.state;
  const { apps, settings } = loggedInUser;
  return (
    <>
      {category !== "notifications" && <Metabar store={store} />}
      {/* Disabled https://idconnect.atlassian.net/browse/IIV01-2659*/}
      {/* HelpMessages state={store.state} */}
      <ProfileToggle profile={loggedInUser} />
      {/* TODO: Quick links should be returned from BE */}
      {reports.reports && reports.reports.length > 0 && (
        <QuickLinksList links={settings} />
      )}
      <Apps apps={apps} />
      <Lists />
    </>
  );
};

const StoreWrapper = () => (
  <Subscribe to={[store]}>{store => <Dashboard store={store} />}</Subscribe>
);

export default StoreWrapper;
